import { render, staticRenderFns } from "./ThgPassword.vue?vue&type=template&id=937236f6"
import script from "./ThgPassword.vue?vue&type=script&lang=ts"
export * from "./ThgPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports